export module WellKnownRoutePaths {

  export const fromRoot = (path: string) => `/${path}`;

  export class CurrentProduct {
    static adminDashboard = '/admin';
  }

  const mojoAdmin = 'mojo/admin';
  const adminPath = (s: string) => `${mojoAdmin}/${s}`;

  export const isMojoAdminRoute = (s: string) => (s || '').indexOf(mojoAdmin) > -1;

  export class MojoDashboards {
    static selectProductDashboard = adminPath('select');
    static systemSettings = adminPath('system-settings');
    static adminDashboard = adminPath('dashboard');
    static identityServerDashboard = adminPath('ids-dashboard');
    static manageWidgets = adminPath('manage-widgets');
    static manageProfiles = adminPath('manage-profiles');
    static assignProfiles = adminPath('assign-profiles');
    static emailTemplates = adminPath('email-templates');
    static supportPage = adminPath('support');
    static cancelActivities = adminPath('cancel-activities')
    static faqPage = adminPath('manage-faqs');


  }
}
